export const handleVisibilityChange = () => {
    if (document.hidden) {
      const audioElements = document.querySelectorAll('audio');
      audioElements.forEach((audio) => {
        audio.pause();
      });
    }
  };
